
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

import information from './information'
import detail from './detail'
import newsList from './news/index'
import newsdetail from './news/detail'
import axios from "axios";
export default new Vuex.Store({
  modules: {
    information,
    detail,
    newsList,
    newsdetail,
  },
  state:{
     isshow:false,
     show:true,
     type:1,
     error:'',
     error2:'',
     isyzm1:0,
     isyzm2:0,
  },
  mutations:{
    openPop(state,value){
        state.isshow=value.isopen;
        state.type=value.type
    },
    offpop(state,value){
      console.log(value)
       state.isshow=value;
       state.show=true;
    },
    yamCountdown1(){
      var _this=this;
      if(state.isyzm1>0){
        state.isyzm1--;
        setTimeout(function(){
          _this.yamCountdown1();
        },1000);
      }
    },
    yamCountdown2(){
      var _this=this;
      if(state.isyzm2>0){
        state.isyzm2--;
        setTimeout(function(){
          _this.yamCountdown2();
        },1000);
      }
    },
    submintYZM(state,form){
      var patten=/^(((0[0-9]{2,3}-?)?([2-9][0-9]{6,7})+(-?[0-9]{1,4})?)|(((\\+?86)|(\\(\\+86\\))|(0))?(1[3456789][0123456789][0-9]{8})))$/;
      if(!patten.test(form.tel)){
        if(form.source==2){
          state.error2='电话格式有误！';
        }else{
          state.error='电话格式有误！';
        }
        return
      }
      var params = new URLSearchParams()
      params.append('mobile',form.tel)
      var _this=this;
      axios.post('https://www.xiaoyu168.com/api/_SendVerificationCode',params,{ headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
        }}).then(d=>{ 
          console.log(d.data)
          if(d.data.Result){
            if(form.source==2){
              var yamCountdown2=function(){
                if(state.isyzm2>0){
                  state.isyzm2--;
                  setTimeout(function(){
                    yamCountdown2();
                  },1000);
                }
              };
              state.isyzm2=60;
              setTimeout(function(){
                yamCountdown2();
              },1000);
            }else{
              var yamCountdown1=function(){
                if(state.isyzm1>0){
                  state.isyzm1--;
                  setTimeout(function(){
                    yamCountdown1();
                  },1000);
                }
              };
              state.isyzm1=60;
              setTimeout(function(){
                yamCountdown1();
              },1000);
            }     
          }else{
            if(form.source==2){
              state.error2="获取验证码失败";
            }else{
              state.error="获取验证码失败";
            }           
          }
      })
      
    },
    submintData(state,form){
      console.log(form)
      var patten=/^(((0[0-9]{2,3}-?)?([2-9][0-9]{6,7})+(-?[0-9]{1,4})?)|(((\\+?86)|(\\(\\+86\\))|(0))?(1[3456789][0123456789][0-9]{8})))$/;
      if(form.name==''){
        if(form.source==2){
          state.error2='请填写姓名！';
        }else{
          state.error='请填写姓名！';
        }
        return
      }else if(!patten.test(form.tel)){
        if(form.source==2){
          state.error2='电话格式有误！';
        }else{
          state.error='电话格式有误！';
        }
        return
      }else if(form.VerificationCode==''){
        if(form.source==2){
          state.error2='请填写验证码！';
        }else{
          state.error='请填写验证码！';
        }
        return
      }
      // else if(form.Product==''){
      //   if(form.source==2){
      //     state.error2='请选择产品！';
      //   }else{
      //     state.error='请选择产品！';
      //   }
      //   return
      // }
      // if(form.Business=='请选择'){
      //   state.error='请选择所属行业'
      //   return
      // }
      // else  if(form.AreaName=='请选择'){
      //   state.error='请选择区域'
      //   return
      // }
      var params = new URLSearchParams()
       params.append('Business',form.Business)
       //params.append('AreaName',form.AreaName)
       params.append('UserName', form.name)
       params.append('TelPhone', form.tel)
       params.append('IndustryType', form.IndustryType)
      //  params.append('Product', form.Product)
       params.append('Product', "智能电话机器人")
       params.append('VerificationCode', form.VerificationCode)
       
       axios.post('https://www.xiaoyu168.com/api/_Register',params,{ headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
       }}).then(d=>{ 
          console.log(d.data)
          if(d.data.Result){
              state.show=false;
          }else{
            if(form.source==2){
              state.error2=d.data.Message;
            }else{
              state.error=d.data.Message;
            }           
          }
      })
    }
  },
})





// WEBPACK FOOTER //
// ./src/store/index.js